/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для селекта предоплаты
   */
  app.JointPurchaseSelectPrepaymentView = app.TabsBaseItemView.extend({
    tabClass: 'tab',
    events: {
      'click .tab': 'tabClick'
    },
    tabClick: function (e) {
      var that = this;
      // скрываем весь контент и делаем все табы не активными
      this.$('.' + this.tabClass).each(function () {
        var $tab = that.$(this);
        
        that.hideTab($tab);
      });
      
      // устанавдиваем активный таб и показываем его контет
      var $tab = this.$(e.currentTarget);
      
      this.showTab($tab, e.originalEvent);
      
      // Скрываем или показываем параметры предоплаты
      $('.js-prepay').toggleClass('not_display', !$tab.data('value'));
    },
    hideTab: function (tab) {
      tab.removeClass(this.activeTabClass);
    },
    showTab: function (tab, userChange) {
      if (userChange) {
        this.$('input').val(tab.data('value')).trigger('change');
      }
      tab.addClass(this.activeTabClass);
    },
    showContent: function () {
    },
    hideContent: function () {
    }
  });
})();

}.call(window));